/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.list', {
      url: '/list?bucket&categoryId&clientId',
      params: {
        bucket: { dynamic: true, inherit: false, value: null },
        categoryId: { dynamic: true, inherit: false, value: 'ALL' },
        clientId: { dynamic: true, inherit: false, value: 'ALL' },
      },
      template: '<list></list>',
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/list/list.routes.js